import React, { forwardRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cx } from '../utils';
import './Pagination.css';

const range = (from, to) => Array.from({ length: to - from + 1 }, (_, index) => from + index);

// Ko'rsatiladigan elementlar: sahifa raqamlari va "…" ("ellipsis-left" / "ellipsis-right").
export function getPageItems(page, totalPages, siblings = 1) {
  const total = Math.max(1, totalPages);
  if (total <= siblings * 2 + 5) return range(1, total);

  const left = Math.max(page - siblings, 1);
  const right = Math.min(page + siblings, total);
  const showLeftDots = left > 3;
  const showRightDots = right < total - 2;
  const edgeCount = 3 + siblings * 2;

  if (!showLeftDots && showRightDots) return [...range(1, edgeCount), 'ellipsis-right', total];
  if (showLeftDots && !showRightDots) return [1, 'ellipsis-left', ...range(total - edgeCount + 1, total)];
  return [1, 'ellipsis-left', ...range(left, right), 'ellipsis-right', total];
}

// Faqat ko'rinish: page 1 dan boshlanadi. skip/limit hisobi chaqiruvchi sahifada qoladi.
// onPageChange faqat chegaradagi va joriydan farqli sahifa uchun chaqiriladi.
// disabled — barcha tugmalar o'chiriladi (masalan ma'lumot yuklanayotganda).
const Pagination = forwardRef(function Pagination(
  {
    page,
    totalPages,
    onPageChange,
    siblings = 1,
    disabled = false,
    prevLabel = 'Oldingi sahifa',
    nextLabel = 'Keyingi sahifa',
    className,
    ...rest
  },
  ref
) {
  if (!totalPages || totalPages < 1) return null;

  const goTo = (target) => {
    if (!disabled && target >= 1 && target <= totalPages && target !== page && onPageChange) {
      onPageChange(target);
    }
  };

  return (
    <nav {...rest} ref={ref} aria-label={rest['aria-label'] || 'Sahifalash'} className={cx('ui-pagination', className)}>
      <button
        type="button"
        className="ui-pagination__btn ui-pagination__btn--nav"
        onClick={() => goTo(page - 1)}
        disabled={disabled || page <= 1}
        aria-label={prevLabel}
      >
        <ChevronLeft aria-hidden="true" />
      </button>

      {getPageItems(page, totalPages, siblings).map((item) =>
        typeof item === 'number' ? (
          <button
            key={item}
            type="button"
            className={cx('ui-pagination__btn', item === page && 'ui-pagination__btn--active')}
            onClick={() => goTo(item)}
            disabled={disabled}
            aria-current={item === page ? 'page' : undefined}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="ui-pagination__ellipsis" aria-hidden="true">
            …
          </span>
        )
      )}

      <button
        type="button"
        className="ui-pagination__btn ui-pagination__btn--nav"
        onClick={() => goTo(page + 1)}
        disabled={disabled || page >= totalPages}
        aria-label={nextLabel}
      >
        <ChevronRight aria-hidden="true" />
      </button>
    </nav>
  );
});

export default Pagination;
